import Auth from './auth.js'
import Api from './lib/api.js';
import DlgPrivacy from './lib/privacy.js'
import IVPForm from './lib/form.js'
import IVPLoader from './lib/loader.js'
import DlgPopup from './lib/popup-dialog.js';
import DlgContractorDocument from './lib/contractor-document.js'

document.addEventListener("DOMContentLoaded",async()=>{
           
    document.querySelector("#sidebar-menu .contractor-documents").classList.add("active")

    IVPLoader.Show()

    if (await Auth.Init() == false)
        return

    if (Auth.user.privacy_accepted == false)
        await DlgPrivacy.EnsureAccepted()

    let disabled = true
    const urlParams = new URLSearchParams(window.location.search);

    let contractor_id = urlParams.get("id")

    if (Auth.user.profile == "ADMIN") {
        document.querySelector(".navbar-header .breadcrumb").append($(`<li class="breadcrumb-item"><a href="contractors.html">Lista Contractors</a></li>`)[0])
        document.querySelector(".navbar-header .breadcrumb").append($(`<li class="breadcrumb-item active">Modifica contractor</li>`)[0])
        disabled = false
    }
    else if (contractor_id == null && Auth.user.profile=="CUSTOMER") {
        contractor_id = "self"
        document.querySelector(".anagrafica").classList.add("hidden")
        disabled = true        
        document.querySelector(".navbar-header .breadcrumb").append($(`<li class="breadcrumb-item active">Documenti</li>`)[0])    
    }
    else {
        document.querySelector(".navbar-header .breadcrumb").append($(`<li class="breadcrumb-item"><a href="contractors.html">Lista Contractors</a></li>`)[0])
        document.querySelector(".navbar-header .breadcrumb").append($(`<li class="breadcrumb-item active">Dati contractor</li>`)[0])    
        disabled = true
    }

    let rows = await Api.GetContractor(contractor_id)
    contractor_id = rows[0].id

    let documents = await Api.GetContractorDocuments(contractor_id)

    let data = rows[0]
    let form = new IVPForm([
        {
            type: "hidden",
            name: "id",
            value: data.id,
            disabled: disabled
        },
        {
            type: "text",
            name: "name",
            label: "Nominativo",
            placeholder: "Ragione sociale del contractor",
            value: data.name,
            disabled: disabled
        },
        {
            type: "text",
            name: "address",
            label: "Indirizzo",
            placeholder: "Indirizzo del contractor",
            value: data.address,
            disabled: disabled
        }, 
        , 
        {
            type: "text",
            name: "zip",
            label: "CAP",
            placeholder: "",
            value: data.zip,
            length: 2,
            disabled: disabled
        },        
        {
            type: "text",
            name: "city",
            label: "Città",
            placeholder: "Città del contractor",
            value: data.city,
            disabled: disabled
        }, 
        {
            type: "text",
            name: "province",
            label: "Provincia",
            placeholder: "Provincia del contractor",
            value: data.province,
            length: 1,
            disabled: disabled
        },              
        {
            type: "text",
            name: "vat",
            label: "Partita IVA",            
            value: data.vat,
            length: 4,
            disabled: disabled
        },          
        {
            type: "email",
            name: "email",
            label: "Email",            
            value: data.email,
            disabled: disabled
        },                
        {
            type: "email",
            name: "pec",
            label: "Pec",            
            value: data.pec,
            disabled: disabled
        },         
        {
            type: "phone",
            name: "phone",
            label: "Telefono",            
            value: data.phone,
            length: 4,
            disabled: disabled
        },         
        {
            type: "text",
            name: "iban",
            label: "IBAN",            
            value: data.iban,
            length: 4,
            disabled: disabled
        },       
        {
            type: "text",
            name: "sdi_code",
            label: "Codice SDI",            
            value: data.sdi_code,
            length: 2,
            disabled: disabled
        },
        {
            type: "select",
            name: "reviewer_id",
            label: "Revisore",            
            options: [
                { value: null, label: "Non assegnato" },
                { value: '84', label: "Assegnato" },
            ],
            value: data.reviewer_id,
            length: 4,
            disabled: disabled
        }
        
    ], [
        
    ])

    if (Auth.user.profile == "ADMIN") {
        form.buttons.push ({
            label: "Salva",
            primary: true,
            action: "save",
            disabled: false
        })

        form.fields.push ({
            type: "text",
            name: "login",
            label: "Login",            
            value: data.login,
            length: 4,
            disabled: false
        })

        form.fields.push ({
            type: "text",
            name: "secret",
            label: "Password",            
            value: data.secret,
            length: 4,
            disabled: false
        })

        form.fields.push ({
            type: "hidden",
            name: "auth_id",
            value: data.auth_id,
            disabled: false
        })

     
    }
         

    form.OnSubmit = async (submit) => {
        console.log(submit)
        if (String(submit.data.name).trim() == "")
            return await DlgPopup.Show("Dati non validi","E' necessario impostare il nominativo")

        if (String(submit.data.login).trim() == "" || 
            String(submit.data.secret).trim() == "")
            return await DlgPopup.Show("Dati non validi","E' necessario impostare login e password")


        try {
            IVPLoader.Show(null,"Salvataggio dati")

            await Api.SaveContractor(submit.data)

            document.location.href = "/contractors.html"
        }
        catch (Ex) {            
            console.error(Ex)
            IVPLoader.Remove()
            if (Ex.response != null && Ex.response.status == 409)
                DlgPopup.Show("Nome duplicato",`Il nome ${submit.data.login} è già assegnato ad un'altra utenza (admin, operatore o contractor).`)
            else
                DlgPopup.Show("Errore","Ooops! Qualcosa è andato storto. Riprovare.")
        }        
    }

    document.querySelector(".form-container").append(form)


    let btb = $('#basic-datatable').DataTable({
        "pageLength": 50,
        "language": {
            "paginate": {
                "previous": "<i class='mdi mdi-chevron-left'>",
                "next": "<i class='mdi mdi-chevron-right'>"
            },
            processing:     "Elaborazione dati...",
            search:         "Ricerca&nbsp;:",
            lengthMenu:    "Visualizza _MENU_ record",
            info:           "Visualizzati da _START_ a _END_ di _TOTAL_ record",
            infoEmpty:      "Nessun record in archivio",
            infoFiltered:   "(trovati su _MAX_ in totale)",
            infoPostFix:    "",
            loadingRecords: "Caricamento dati...",
            zeroRecords:    "Nessun record",
            emptyTable:     "Archivio vuoto",
            sortAscending:  ": activer pour trier la colonne par ordre croissant",
            sortDescending: ": activer pour trier la colonne par ordre décroissant"
        },
       
        columns: [                        
            { title: 'Nome documento', data: 'name' },
            { title: 'File documento', data: 'file' },
            { title: ' ', data: '' },
        ],
        columnDefs: [
            {
                targets: [1],
                render: function (data, type, row) {
                    return `<a href="javascript:void(0)" class="link_view_file">${data}</a>`;   
                },
            },
            {  
                targets: [-1],
                render: function (data, type, row) {
                    if (Auth.user.profile != "ADMIN")
                        return ""
                    return `
                        <button type='button' class='btnEdit btn btn-outline-secondary btn-sm'>Modifica</button>
                        <button type='button' class='btnDelete btn btn-outline-secondary btn-sm'>Elimina</button>
                    `;   
                },
                
            },
        ],
        data: documents,
        initComplete: ()=>{
            let disabled = ""
            if (Auth.user.profile == "CUSTOMER") 
                disabled = 'disabled aria-disabled="true"'
            
            if (Auth.user.profile == "ADMIN") {
                let btn = $(`<button type="button" class="btnAdd btn btn-outline-secondary btn-sm mr-2" ${disabled}>+ Nuovo</button>`)
                btn.click(async (e)=>{                                
                    let file = await DlgContractorDocument.Show()
                    if (file != null) {
                        IVPLoader.Show()
                        try {                        
                            await Api.SaveContractorDocuments(contractor_id, file)
                            documents = await Api.GetContractorDocuments(contractor_id)
                            btb.clear()
                            btb.rows.add(documents)                        
                            btb.draw(false)
                        }
                        catch (Ex) {
                            console.error(Ex)
                        }
                        IVPLoader.Remove()
                    }
                })
                $("#basic-datatable_filter").prepend(btn)
            }
        }
    });

    let fnEdit = ()=> {
        $("#basic-datatable .btnEdit").off('click')
        $("#basic-datatable .btnEdit").click( async (e)=>{
            let tr = btb.row(e.target.closest('tr'))     
            let file = tr.data()       
            console.log(tr.data())

            file = await DlgContractorDocument.Show(file)
            if (file != null) {
                IVPLoader.Show()
                try {                        
                    await Api.SaveContractorDocuments(contractor_id,file)
                    documents = await Api.GetContractorDocuments(contractor_id)
                    btb.clear()
                    btb.rows.add(documents)                        
                    btb.draw(false)
                }
                catch (Ex) {
                    console.error(Ex)
                    DlgPopup.Show("Errore","Ooops! Qualcosa è andato storto. Riprovare.")
                }
                IVPLoader.Remove()
            }            
        })
        
        $("#basic-datatable .link_view_file").off('click')
        $("#basic-datatable .link_view_file").click( async (e)=>{
            let tr = btb.row(e.target.closest('tr'))     
            let file = tr.data()       
            console.log(tr.data())
            await DlgContractorDocument.Show(file,true)      
        })

        $("#basic-datatable .btnDelete").off('click')
        $("#basic-datatable .btnDelete").click( async (e)=>{
            let tr = btb.row(e.target.closest('tr'))     
            let file = tr.data()       
            console.log(tr.data())

            if (await DlgPopup.Show("Conferma","Confermi eliminazione del documento: "+file.name,"Elimina","Annulla") == true) {
                IVPLoader.Show()
                try {                        
                    await Api.DeleteContractorDocuments(contractor_id,file.id)
                    tr.remove()                      
                    btb.draw(false)
                    IVPLoader.Remove()
                }
                catch (Ex) {
                    console.error(Ex)
                    IVPLoader.Remove()
                    DlgPopup.Show("Errore","Ooops! Qualcosa è andato storto. Riprovare.")
                }                
            }            
        })        
    }

    fnEdit()
    
    btb.on( 'draw init.dt', fnEdit)

    document.querySelector(".page-content").classList.remove("hidden")

    IVPLoader.Remove()

})
